import { render, staticRenderFns } from "./BasicAppbar.vue?vue&type=template&id=9be8d46a"
import script from "./BasicAppbar.vue?vue&type=script&lang=js"
export * from "./BasicAppbar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports